import { ContentDivider } from '../ContentDivider';
import { Button, ButtonSegment } from '../Input2';
import { Communication, Users } from '../StrokeIcons';

import type { OrgTabId } from './types';

type OrgSwitcherPureProps = {
  activeTab: OrgTabId;
  onTabChange: (tab: OrgTabId) => void;
};

/**
 * Pure Interact/Data tab switcher. The router-driven `OrgSwitcher` in the
 * dashboard becomes this controlled component; each surface owns how `activeTab`
 * is stored (dashboard: router query; extension: local state).
 */
export const OrgSwitcherPure = ({ activeTab, onTabChange }: OrgSwitcherPureProps) => (
  <ContentDivider size="sm" align="center">
    <ButtonSegment<OrgTabId> size="sm" selectedId={activeTab} onChange={onTabChange}>
      <Button id="interact" icon={<Communication.MessageSmileCircle />}>
        Interact
      </Button>
      <Button id="data" icon={<Users.User03 />}>
        Data
      </Button>
    </ButtonSegment>
  </ContentDivider>
);
